import { FormControl, FormGroup } from '@angular/forms';

export const CONSTS = {
  HEADER: $localize`Exception Processing Export`,
  DATE_LABEL: $localize`Date`,
  ROUTE_LABEL: $localize`Route Id`,
};

export const REPORT_FILE_NAME = 'Exception-Processing-Report';

type ExceptionProcessingFormField = {
  date: FormControl<Date>;
  routes: FormControl<string>;
};

export type ExceptionProcessingFormGroup =
  FormGroup<ExceptionProcessingFormField> | null;
